import { useEffect, useState } from "react";
import { getCuentaCorrientePendientes } from "../services/soloPendientes";

export const useDocumentosPendientes = (idCliente, idTipoNegocio) => {
  const [documentos, setDocumentos] = useState([]);
  const [totales, setTotales] = useState({ debe: 0, haber: 0, saldo: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const obtenerDocumentos = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCuentaCorrientePendientes(idCliente, idTipoNegocio);
      setDocumentos(data.movimientos);
      setTotales({
        debe: data.saldos?.debito,
        haber: data.saldos?.credito,
        saldo: data.saldos?.saldo,
      });
    } catch (error) {
      setError(
        error.message || "Ocurrio un error al traer los documentos pendientes",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerDocumentos();
  }, []);

  return {
    documentos,
    totales,
    loading,
    error,
    refresh: obtenerDocumentos,
  };
};
